<!-- @format -->

<template>
    <div class="export-form">
        <b-card bg-variant="light">
            <b-card-header header-tag="header" role="tab" header-bg-variant="primary">
                <div block v-b-toggle.form variant="info">
                    {{ $t("export.formTitle") }}
                </div>
            </b-card-header>
            <b-collapse id="form" visible accordion="form" role="tabpanel">
                <b-card-body>
                    <div class="form-container">
                        <div class="layout-container">
                            <div class="input-wrapper">
                                <b-form-group
                                    :label="$t('export.userSelect')"
                                    label-class="form-label"
                                    label-for="user-select">
                                    <v-select
                                        @search="retrieveUsers()"
                                        taggable
                                        multiple
                                        id="user-select"
                                        v-model="formData.users"
                                        :options="users"
                                        :reduce="option => option.value"
                                        label="text" />
                                </b-form-group>
                                <div>
                                    <base-date-picker
                                        @change="formData.startDate = $event"
                                        :value="formData.startDate"
                                        label="Start Datum" />
                                    <base-date-picker
                                        @change="formData.endDate = $event"
                                        :value="formData.endDate"
                                        label="End Datum" />
                                </div>
                            </div>
                            <div style="height: 100%; display: flex; flex-direction: row-reverse; align-items: end">
                                <b-button variant="primary" @click="retrieveTickets">{{
                                    $t("export.search")
                                }}</b-button>
                                <b-button variant="primary" @click="downloadCSV" v-if="csv">{{
                                    $t("export.download")
                                }}</b-button>
                            </div>
                        </div>
                    </div>
                </b-card-body>
            </b-collapse>
        </b-card>
    </div>
</template>

<script>
import AZ from "@/utils/AzApi";
import BaseDatePicker from "./BaseDatePicker.vue";
export default {
    components: { BaseDatePicker },
    name: "ExportForm",
    data: () => {
        return {
            pojectTicketRegex: RegExp(/\[(.*?)(TEG.*?)\](.*)/),
            formData: {
                users: [],
                startDate: "",
                endDate: ""
            }
        };
    },
    props: {
        users: Array,
        csv: ""
    },
    mounted() {
        const today = new Date();

        const firstDay = new Date(today.getFullYear(), today.getMonth(), 1, 12);
        const lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0, 12);
        console.log(today, firstDay, lastDay);
        this.formData.startDate = firstDay.toISOString().substring(0, 10);
        this.formData.endDate = lastDay.toISOString().substring(0, 10);
    },
    methods: {
        retrieveTickets() {
            AZ.getExportData(this.formData.users, this.formData.startDate, this.formData.endDate).then(res => {
                this.$emit("export", res.data);
            });
        },
        downloadCSV() {
            const link = document.createElement("a");
            link.setAttribute("href", this.csv);
            link.setAttribute("download", "times.csv");
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    }
};
</script>

<style scoped>
button {
    margin: 2rem 1rem;
    float: right;
}

.card-header {
    font-size: 1.2rem;
    background-color: var(--primary);
    color: white;
}

.card-body {
    padding: 0;
}

.form-container {
    padding: 2rem;
}

@media (min-width: 768px) {
    .layout-container {
        display: grid;
        grid-template-columns: 1fr 1fr;
    }

    .layout-container > div {
        padding: 0 1rem;
    }
}
@media (max-width: 768px) {
    button {
        width: 100%;
        margin: 0.4rem 0;
        float: none;
    }
    .form-container {
        padding: 1rem;
    }
}

.vs--searchable .vs__dropdown-toggle {
    background-color: white;
}
</style>
